import _ from 'lodash'
import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Role add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminRoleForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminRoleFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminRoleForm}.
 *
 * @type {ngController}
 */
export class tmrAdminRoleFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    $translate
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { $translate })
  }

  $onInit() {
    super.$onInit()

    // Default value for frontPage field.
    if (this.resource.data && this.resource.data.frontPage) {
      let state = this.$state.get(this.resource.data.frontPage)
      if (state) {
        this.frontPage = this.frontPageOption(
          state.label,
          this.resource.data.frontPage,
          this.$state.href(this.resource.data.frontPage, {}, { inherit: false })
        )
      }
    }
  }

  frontPageOptions() {
    if (this.pageList === undefined) {
      let states = this.$state.router.stateRegistry.get()
      // Best effort to build a readable list of routes.
      this.pageList = states.reduce(
        (pageList, { abstract, label, name, url, weight }) => {
          if (
            !abstract &&
            label &&
            this.$translate.instant(label) !== label &&
            url
          ) {
            let href = this.$state.href(name, {}, { inherit: false })
            if (href)
              pageList.push(this.frontPageOption(label, name, href, weight))
          }
          return pageList
        },
        [] /* init pageList */
      )
    }

    if (this.frontPageText) {
      return this.pageList.filter(({ label }) =>
        label
          .toLocaleLowerCase()
          .includes(this.frontPageText.toLocaleLowerCase())
      )
    }

    return this.pageList
  }

  frontPageOption(label, name, href, weight = 0) {
    return {
      label: this.$translate.instant(label),
      name,
      url: href.replace('#!', '').split('?')[0], // #!/foo/bar?baz becomes /foo/bar
      weight,
    }
  }

  /**
   * Overrides tmrResourceFormController.onSubmit()
   *
   * Before submit:
   * - Copies frontPage name to role resource
   * - Check if frontPage is valitated by capabilities
   */
  onSubmit() {
    if (this.frontPage) {
      this.resource.data.frontPage = this.frontPage.name
    } else {
      delete this.resource.data.frontPage
      return super.onSubmit()
    }

    let state = this.$state.get(this.frontPage.name)
    if (
      !state.accessControl.length ||
      !!_.intersection(this.resource.capabilities, state.accessControl).length
    ) {
      return super.onSubmit()
    } else {
      /** @todo Convert to TmrToast.exception */
      return this.TmrToast.translate('ADMIN.ERRORS.INVALIDFRONTPAGE')
    }
  }
}
